import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { BaseUpdateComponent } from '@app/shared/components/base/base-update.component';
import { AddressBookEntry } from '@app/shared/models/address-book-entry';
import { AddressBookEntryService, AddressBookEntryUriBuilderParams } from '@app/core/services/address-book-entry.service';

@Component({
    selector: 'address-book-entry',
    templateUrl: './address-book-entry.component.html',
    styleUrls: ['./address-book-entry.component.scss']
})
export class AddressBookEntryComponent extends BaseUpdateComponent<AddressBookEntry, AddressBookEntryUriBuilderParams>
                                       implements OnInit {

    @Output()
    public canceled = new EventEmitter();

    protected paramsIdNames = [];

    get addressBookEntry() {
        return this.updated;
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected addressBookEntryService: AddressBookEntryService) {
        super(componentServiceBundle, addressBookEntryService);
        this._idPrefix = 'address_book_entry.';
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public cancel(): void {
        this.canceled.emit();
    }

    public submit(): void {
        this.addressBookEntry.address.copyPostalCodes();
        this.addressBookEntry.address.splitCountry();

        if (!this.addressBookEntry.id) {
            this.addressBookEntryService.create(this.generateUriBuilderParams(), this.addressBookEntry)
                                        .subscribe(result => {
                this.afterChange(result);
            });
        } else {
            this.update();
        }
    }

    protected generateUriBuilderParams(): AddressBookEntryUriBuilderParams {
        return new AddressBookEntryUriBuilderParams(this.original);
    }

}
